<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar
                show_search
                show_month
                :loading="loader"
                :search.sync="search"
                :chosen_month.sync="chosen_month"
            >
                <v-flex xs12 md2>
                    <v-select
                        label="Hình thức"
                        :disabled="loading.submit"
                        v-model="chosen_payment_type"
                        :items="list_payment_type"
                        prepend-icon="monetization_on"
                        required
                        hide-details
                    ></v-select>
                </v-flex>
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="dialog = !dialog" color="green" dark>
                            <v-icon small dark class="mr-1">add_box</v-icon>Thu Tiền Phòng
                        </v-btn>

                        <dialog-tao-phieu-thu-khac @getData="getData"></dialog-tao-phieu-thu-khac>

                        <v-btn
                            :loading="export_csv.loading"
                            @click="exportCSV"
                            color="primary"
                            dark
                        >XUẤT EXCEL</v-btn>
                        <export-csv-button
                            :trigger="export_csv.trigger"
                            :title="export_csv.title"
                            :rows="export_csv.rows"
                        ></export-csv-button>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            :rows-per-page-items="rowPerPage"
                            :headers="headers"
                            :items="filtered_items"
                            disable-initial-sort
                            :loading="form_loader"
                            :search="search"
                            item-key="id"
                        >
                            <template #items="props">
                                <tr>
                                    <td>
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on">
                                                    <v-icon small color="#464D69">settings</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile
                                                    @click="triggerDialog(props.item, 'edit')"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-edit"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Chỉnh sửa
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    v-if="props.item.is_valid && !props.item.is_collected"
                                                    @click="removeReceipt(props.item)"
                                                >
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>
                                                        Xóa phiếu
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </td>
                                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.date_collected | formatTimeServer }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">
                                        <span
                                            :class="props.item.is_collected ? 'v-badge primary' : 'v-badge warning'"
                                        >{{ props.item.is_collected ? 'Chủ Trọ đã thu' : 'Chủ Trọ chưa thu' }}</span>
                                    </td>
                                    <td class="text-center text-no-wrap">
                                        <span
                                            :class="props.item.type == 'receipt_room' ? 'v-badge primary' : 'v-badge info'"
                                        >{{ props.item.type == 'receipt_room' ? 'Tiền phòng' : 'Thu khác' }}</span>
                                    </td>
                                    <td
                                        class="text-right text-no-wrap"
                                    >{{ props.item.collected_amount | formatNumber }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.month }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.wallet_account_id | translateWalletName }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.receipt_collected_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.note }}</td>
                                </tr>
                            </template>
                            <template #no-data>Chưa có thông tin</template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" max-width="80%">
            <app-card>
                <app-section-loader :status="form_loader"></app-section-loader>
                <h4>PHIẾU THU TIỀN PHÒNG</h4>
                <p class="fs-14 grey--text">Tạo phiếu thu tiền phòng</p>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Tòa nhà"
                                    :disabled="loading.submit"
                                    v-model="form.building"
                                    :items="list_building"
                                    prepend-icon="domain"
                                    :rules="[rules.required]"
                                    required
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select
                                    label="Số phòng"
                                    :disabled="loading.submit"
                                    v-model="form.room_id"
                                    :items="room_ids"
                                    item-text="room_id"
                                    item-value="rooms_id"
                                    prepend-icon="meeting_room"
                                    :rules="[rules.required]"
                                    required
                                    @change="findReceiptPayment()"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_receipt_data_month"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.month"
                                        label="Chọn tháng"
                                        :disabled="loading.submit"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <v-date-picker
                                        min="2019-10"
                                        locale="vi-VI"
                                        type="month"
                                        v-model="form.month"
                                        @change="findReceiptPayment()"
                                        @input="menu_receipt_data_month = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu
                                    :close-on-content-click="false"
                                    v-model="menu_receipt_date_collected"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                >
                                    <v-text-field
                                        slot="activator"
                                        v-model="form.date_collected"
                                        label="Ngày thu"
                                        :disabled="loading.submit"
                                        prepend-icon="event"
                                        readonly
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <v-date-picker
                                        locale="vi-VI"
                                        v-model="form.date_collected"
                                        @input="menu_receipt_date_collected = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 v-if="alert.show">
                                <v-alert
                                    :value="alert.show"
                                    :type="alert.type"
                                    outline
                                >{{ alert.text }}</v-alert>
                            </v-flex>
                            <template v-if="form.room_state_id">
                                <v-flex xs12 md3>
                                    <wallet
                                        :input.sync="form.wallet_account_id"
                                        required
                                        :disabled="loading.submit"
                                    ></wallet>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Mã phiếu thu"
                                        :disabled="(form.wallet_account_id && form.wallet_account_id !== 1) || loading.submit"
                                        v-model="form.receipt_id"
                                        prepend-icon="label"
                                        required
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-text-field
                                        label="Số tiền thu"
                                        :disabled="loading.submit"
                                        v-model="form.collected_amount"
                                        prepend-icon="money"
                                        required
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <v-select
                                        label="Người tạo phiếu"
                                        :disabled="loading.submit"
                                        v-model="form.collector"
                                        :items="list_first_collectors"
                                        required
                                        type="text"
                                        prepend-icon="domain"
                                        :rules="form.wallet_account_id !== 1 ? [] : [rules.required]"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        label="Ghi chú"
                                        :disabled="loading.submit"
                                        v-model="form.note"
                                        prepend-icon="event_note"
                                    ></v-text-field>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-container>
                    <v-card-actions v-if="form.room_state_id">
                        <v-spacer></v-spacer>
                        <v-btn :disabled="loading.submit" @click="cancelInput">Trở về</v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >Tạo Phiếu Thu Tiền Phòng</v-btn>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-dialog>

        <edit-receipt-component
            hide_button
            :receipt_type="chosen_receipt.type"
            title="CHỈNH SỬA PHIẾU THU TIỀN PHÒNG"
            :edit_field="chosen_receipt.type ? this['edit_field_' + chosen_receipt.type] : edit_field_receipt_room"
            :trigger="trigger_edit_component"
            :selected_receipt="chosen_receipt"
            @updateCurrentReceipt="updateCurrentReceipt"
        ></edit-receipt-component>
    </div>
</template>
<script>
import api from "../../api";
import moment from "moment";
import {
    buildParamQuery,
    formatTimeServer,
    dayDiff,
    translateWalletName
} from "../../helpers/helpers.js";
import { list_building } from "../../constants/db-config";
import EditReceiptComponent from "../../components/Phieu/EditReceiptComponent";
import { Wallet } from "../../components/Form";
import ExportCsvButton from "../../components/ExportExcel/ExportCsvButton";
import DialogTaoPhieuThuKhac from "../PhieuThuTien/DialogTaoPhieuThuKhac";
export default {
    name: "phieu-thu-tien-phong",
    components: {
        EditReceiptComponent,
        Wallet,
        ExportCsvButton,
        DialogTaoPhieuThuKhac
    },
    data() {
        return {
            dialog: false,
            menu_receipt_data_month: false,
            menu_receipt_date_collected: false,
            menu_month_picker: false,
            chosen_month: moment()
                .subtract(1, "months")
                .toISOString()
                .substr(0, 7),
            rules: {
                required: value => !!value || "Vui lòng điền thông tin này."
            },
            form: {
                receipt_id: "",
                building: "",
                room_id: "",
                date_collected: "",
                note: "",
                room_state_id: "",
                collector: "",
                month: "",
                collected_amount: "",
                wallet_account_id: null
            },
            list_building,
            list_first_collectors: [
                { text: "BVBN", value: "BVBN" },
                { text: "BVGB", value: "BVGB" },
                { text: "BVTT", value: "BVTT" },
                { text: "BVXA", value: "BVXA" },
                { text: "BVMA", value: "BVMA" },
                { text: "BVBMT", value: "BVBMT" }
            ],
            loader: false,
            headers: [
                {
                    text: "Thao tác",
                    align: "center",
                    sortable: false,
                    value: ""
                },
                {
                    text: "Số chứng từ",
                    align: "center",
                    sortable: true,
                    value: "receipt_id"
                },
                {
                    text: "Ngày thu",
                    align: "center",
                    sortable: true,
                    value: "date_collected"
                },
                {
                    text: "Số phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Trạng thái phiếu",
                    align: "center",
                    sortable: true,
                    value: "receipt_collected_id"
                },
                {
                    text: "Loại",
                    align: "center",
                    sortable: true,
                    value: "type"
                },
                {
                    text: "Số tiền",
                    align: "right",
                    sortable: true,
                    value: "collected_amount"
                },
                {
                    text: "Tháng",
                    align: "center",
                    sortable: false,
                    value: "month"
                },
                {
                    text: "Hình thức",
                    align: "center",
                    sortable: true,
                    value: "wallet_account_id"
                },
                {
                    text: "Phiếu Chủ Trọ",
                    align: "center",
                    sortable: true,
                    value: "receipt_collected_id"
                },
                {
                    text: "Ghi chú",
                    align: "center",
                    sortable: true,
                    value: "note"
                }
            ],
            items: [],
            loading: {
                submit: false
            },
            alert: {
                show: false,
                text: "",
                type: "error"
            },
            form_loader: false,
            chosen_building: "BN",
            list_search_type: [
                { text: "Số phòng", value: "roomId" },
                { text: "Mã số phiếu", value: "receiptId" },
                { text: "Mã quản lý", value: "roomStateId" },
                { text: "Tên khách hàng", value: "name" }
            ],
            rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
            search: "",
            edit_field_receipt_room: {
                building: {
                    type: "list_building",
                    flex_attr: "xs12 sm4",
                    label: "Tòa nhà",
                    disabled: false,
                    prepend_icon: "domain",
                    rule: "require"
                },
                room_id: {
                    type: "list_room",
                    flex_attr: "xs12 sm4",
                    label: "Số phòng",
                    disabled: false,
                    prepend_icon: "meeting_room",
                    rule: "require"
                },
                date_collected: {
                    type: "date",
                    flex_attr: "xs12 sm4",
                    label: "Ngày thu",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "require"
                },
                collected_amount: {
                    type: "money",
                    flex_attr: "xs12 sm4",
                    label: "Số tiền thu",
                    disabled: false,
                    prepend_icon: "money",
                    rule: "require",
                    min: 0
                },
                wallet_account_id: {
                    type: "wallet",
                    flex_attr: "xs12 sm4",
                    label: "Hình thức thu tiền",
                    disabled: false,
                    rule: "require"
                },
                edit_note: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Giải thích chỉnh sửa",
                    disabled: false,
                    prepend_icon: "event_note",
                    rule: "require"
                }
            },
            edit_field_receipt_other: {
                building: {
                    type: "list_building",
                    flex_attr: "xs12 sm4",
                    label: "Tòa nhà",
                    disabled: false,
                    prepend_icon: "domain",
                    rule: "require"
                },
                month: {
                    type: "month",
                    flex_attr: "xs12 sm4",
                    disabled: false,
                    rule: "require"
                },
                date_collected: {
                    type: "date",
                    flex_attr: "xs12 sm4",
                    label: "Ngày thu",
                    disabled: false,
                    prepend_icon: "event",
                    rule: "require"
                },
                collected_amount: {
                    type: "money",
                    flex_attr: "xs12 sm4",
                    label: "Số tiền thu",
                    disabled: false,
                    prepend_icon: "money",
                    rule: "require",
                    min: 0
                },
                wallet_account_id: {
                    type: "wallet",
                    flex_attr: "xs12 sm4",
                    label: "Hình thức thu tiền",
                    disabled: false,
                    rule: "require"
                },
                edit_note: {
                    type: "text",
                    flex_attr: "xs12 sm4",
                    label: "Giải thích chỉnh sửa",
                    disabled: false,
                    prepend_icon: "event_note",
                    rule: "require"
                }
            },
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            list_payment_type: [
                { text: "Tất cả", value: "" },
                { text: "Tiền mặt", value: "cash" },
                { text: "Chuyển khoản", value: "bank" }
            ],
            chosen_payment_type: "",
            chosen_receipt: {},
            trigger_edit_component: false
        };
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        room_ids() {
            return this.rooms.filter(
                room => room.building === this.form.building
            );
        },
        filtered_items() {
            return this.items.filter(item => {
                if (!this.chosen_payment_type) return true;
                else if (
                    this.chosen_payment_type == "cash" &&
                    item.wallet_account_id == 1
                )
                    return true;
                else if (
                    this.chosen_payment_type == "bank" &&
                    item.wallet_account_id != 1
                )
                    return true;
                return false;
            });
        }
    },
    watch: {
        "form.collected_amount": function(nv, ov) {
            this.formatMoney();
        },
        "form.wallet_account_id": function(nv, ov) {
            if (nv && nv !== 1) {
                this.form.receipt_id =
                    this.form.month +
                    "-" +
                    this.form.room_state_id +
                    "-" +
                    (this.form.list_receipt_room_id &&
                    this.form.list_receipt_room_id.length
                        ? this.form.list_receipt_room_id.length + 1
                        : 1);
            }
        },
        chosen_month: {
            handler: function(nv) {
                this.getData();
                this.chosen_month_locale = formatTimeServer(nv + "-01");
            },
            immediate: true
        }
    },
    methods: {
        validate: function(type) {
            // type == 0 => validate form.check_out_type == 1
            // type == 1 => validate form.check_out_type == 2 && step 1
            if (type == 1) {
            }
            // type == 1 => validate form.check_out_type == 2 && step 2
            return true;
        },
        clearInput: function() {
            this.form = {
                receipt_id: "",
                building: "",
                room_id: "",
                date_collected: "",
                note: "",
                room_state_id: "",
                collector: "",
                month: "",
                collected_amount: "",
                wallet_account_id: null
            };
        },
        getData: async function() {
            this.items = [];
            const params = {
                // building: this.chosen_building,
                month: this.chosen_month
            };
            const query = buildParamQuery(params);
            this.form_loader = true;
            let data = await api.getReceiptRoomAndOther(query);
            this.form_loader = false;
            this.loader = false;
            if (data.status === 200) {
                this.items = data.data
                    .map(receipt => receipt)
                    .sort((a, b) =>
                        dayDiff(b.date_collected, a.date_collected)
                    );
            } else {
                console.log("Lỗi lúc tải phiếu thu");
            }
        },
        submit: async function() {
            if (!this.$refs.form.validate()) {
                swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
                return;
            }
            this.loading.submit = true;
            this.form_loader = true;
            let postData = Object.assign({}, this.form);
            postData.date_collected = new Date(postData.date_collected);
            postData.collected_amount = Number(
                this.form.collected_amount.replace(/,/g, "")
            );
            let data = await api.createReceiptRoom(postData);
            this.loading.submit = false;
            this.form_loader = false;
            if (data.status == 200) {
                this.dialog = false;
                this.cancelInput();
                this.getData();
                swal.fire(
                    "Thành công",
                    "Tạo phiếu thu tiền phòng thành công",
                    "success"
                );
            } else {
                swal.fire("Lỗi", data.message, "error");
            }
        },
        formatMoney: function() {
            let collected_amount = this.form.collected_amount;
            collected_amount = collected_amount
                ? collected_amount
                      .toString()
                      .replace(/,/g, "")
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : 0;
            this.form.collected_amount = collected_amount;
        },
        findReceiptPayment: async function() {
            if (!this.form.room_id || !this.form.month) {
                return;
            }
            this.alert.show = false;
            this.form_loader = true;
            this.form.receipt_id = "";
            this.form.note = "";
            this.form.room_state_id = "";
            this.form.collector = "";
            this.form.collected_amount = "";
            this.form.wallet_account_id = null;
            const params = {
                roomId: this.form.room_id,
                month: this.form.month
            };
            const query = buildParamQuery(params);
            const data = await api.findPayment(query);
            this.form_loader = false;
            if (data.status === 200 && data.data) {
                this.form.collected_amount =
                    data.data.total_bill - data.data.collected_amount;
                this.form.room_state_id = data.data.room_state_id;
                this.form.list_receipt_room_id = data.data.receipt_room_id;
            } else {
                this.alert.show = true;
                this.alert.text = `Phòng hiện không có thông tin thu tiền cho phòng ${this.form.room_id} vào tháng ${this.form.month}`;
            }
        },
        cancelInput() {
            this.dialog = false;
            this.clearInput();
            this.$refs.form.resetValidation();
        },
        updateCurrentReceipt(_id, updated_field) {
            const selected_receipt = this.items.find(
                receipt => receipt._id === _id
            );
            for (const key in updated_field) {
                if (updated_field.hasOwnProperty(key)) {
                    const element = updated_field[key];
                    selected_receipt[key] = element;
                }
            }
        },
        triggerDialog: function (receipt, type){
            this.chosen_receipt = receipt;
            if (type === 'edit') this.trigger_edit_component = !this.trigger_edit_component;
        },
        removeReceipt: function (receipt){
            let that = this
            swal.fire({
            title: 'Xóa phiếu',
            text: `Bạn có chắc muốn xóa phiếu: ${receipt.receipt_id}, số phòng ${receipt.room_id}?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Xóa phiếu',
            cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true)
                    let data = await api.removeReceiptRoom({_id: receipt._id })
                    that.$store.commit("loading", false)
                    if (data.status == 200){
                        swal.fire('Thành công', data.data.message, 'success');
                        that.getData();
                    } else {
                        swal.fire('Lỗi', data.message, 'error')
                    }
                }
            })
        },
        exportCSV: function() {
            const rows = this.filtered_items.map(item => {
                return {
                    "Tòa nhà": item.building,
                    "Số phòng": item.room_id,
                    "Số chứng từ": item.receipt_id,
                    "Ngày thu": formatTimeServer(item.date_collected),
                    "Số tiền": item.collected_amount,
                    "Trạng thái phiếu": item.is_collected
                        ? "Chủ Trọ đã thu"
                        : "Chủ Trọ chưa thu",
                    Tháng: item.month,
                    "Hình thức": item.wallet_account_id
                        ? translateWalletName(item.wallet_account_id)
                        : "",
                    "Phiếu CG": item.receipt_collected_id,
                    "Ghi chú": item.note
                };
            });
            this.export_csv.rows = rows;
            this.export_csv.title = "phieu-thu-tien-phong" + this.chosen_month;
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
};
</script>

<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>
